import Axios from 'axios';
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil';
import { TRANSFERIR_PASSAGEIRO } from '../types';
import { URL } from '../../util/ambienteActions';

export default function transferirPassageiro (codigoEmpresa, parametros) {
    const url = `${URL}/itinerario/empresa/${codigoEmpresa}/transferir-passageiro`;
    return dispatch => Axios.post(url, parametros , SLOW_REQUEST_CONFIG).then(
        response => dispatch({
          type: TRANSFERIR_PASSAGEIRO,
          payload: response
        })
    );
  }